module.exports = __webpack_public_path__ + "img/icon-housing.3bfb6db6.svg";